import React, { useEffect, useRef, useState } from 'react';
import { TooltipProps } from '@radix-ui/react-tooltip';
import * as Tooltip from 'components/tooltip';

interface TruncatedTextProps extends TooltipProps {
    children: React.ReactNode;
}

const TruncatedText = (props: TruncatedTextProps) => {
    const { children, ...rest } = props;
    const [isTruncated, setIsTruncated] = useState(false);
    const ref = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        if (ref.current && ref.current.offsetWidth < ref.current.scrollWidth) {
            setIsTruncated(true);
        }
    }, []);

    if (isTruncated) {
        return (
            <Tooltip.Root {...rest}>
                <Tooltip.Trigger asChild={true}>
                    <span className={`truncate [&>*]:truncate`}>{children}</span>
                </Tooltip.Trigger>
                <Tooltip.Portal>
                    <Tooltip.Content inverse>
                        <p>{children}</p>
                        <Tooltip.Arrow inverse />
                    </Tooltip.Content>
                </Tooltip.Portal>
            </Tooltip.Root>
        );
    }

    return (
        <span ref={ref} className={'truncate'}>
            {children}
        </span>
    );
};

export type { TruncatedTextProps };
export { TruncatedText };
